module.exports = __webpack_public_path__ + "img/4.b7fb9268.png";